import { useState } from "react";
import { comics } from "@/mocks/comics";

const days = [
  { key: "周一", label: "周一" },
  { key: "周二", label: "周二" },
  { key: "周三", label: "周三" },
  { key: "周四", label: "周四" },
  { key: "周五", label: "周五" },
  { key: "周六", label: "周六" },
  { key: "周日", label: "周日" },
];

export default function Weekly() {
  const [day, setDay] = useState("周五");
  const weekly = comics.filter((c) => c.updateDay === day);

  return (
    <section id="weekly" className="bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-sm font-semibold text-accent-700">
              <i className="ri-calendar-event-line"></i> 周更作品
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">每周固定更新，一话不落</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              每部周更连载都有固定的更新日。按星期浏览当天更新的作品，标记你的追更日历，周更不断追更不迷路。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {days.map((d) => {
            const count = comics.filter((c) => c.updateDay === d.key).length;
            return (
              <button
                key={d.key}
                type="button"
                onClick={() => setDay(d.key)}
                className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-semibold transition-colors ${
                  day === d.key
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                }`}
              >
                <i className="ri-calendar-line text-sm"></i>
                {d.label}
                <span className={`rounded-full px-1.5 text-xs ${day === d.key ? "bg-white/20" : "bg-secondary-100 text-secondary-700"}`}>
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {weekly.map((comic) => {
            const progress = Math.round((comic.latestChapter / comic.totalChapters) * 100);
            return (
              <article
                key={comic.id}
                className="manga-card-hover flex gap-4 rounded-2xl bg-background-100 p-4"
              >
                <div className="relative h-32 w-24 shrink-0 overflow-hidden rounded-xl">
                  <img src={comic.cover} alt={`${comic.title} 周更作品封面`} className="h-full w-full object-cover" />
                  <span className="absolute left-1.5 top-1.5 rounded-md bg-primary-500 px-1.5 py-0.5 text-xs font-bold text-background-50">
                    {comic.updateDay}
                  </span>
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <h3 className="truncate text-base font-bold text-foreground-950">{comic.title}</h3>
                  <p className="mt-1 truncate text-xs text-foreground-500">{comic.author}</p>
                  <div className="mt-1 flex flex-wrap gap-1">
                    {comic.genres.slice(0, 2).map((g) => (
                      <span key={g} className="rounded bg-background-200 px-1.5 py-0.5 text-xs text-foreground-600">
                        {g}
                      </span>
                    ))}
                  </div>
                  <div className="mt-auto pt-2">
                    <div className="flex items-center justify-between text-xs text-foreground-500">
                      <span>{comic.latestChapter} 话</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-star-fill text-secondary-500"></i> {comic.rating}
                      </span>
                    </div>
                    <div className="mt-1 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                      <div
                        className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500"
                        style={{ width: `${progress}%` }}
                      ></div>
                    </div>
                    <a
                      href="#updates"
                      className="mt-2.5 inline-block whitespace-nowrap text-xs font-semibold text-primary-600 hover:text-primary-700"
                    >
                      加入追更 <i className="ri-arrow-right-line ml-0.5"></i>
                    </a>
                  </div>
                </div>
              </article>
            );
          })}
          {weekly.length === 0 && (
            <p className="text-sm text-foreground-500">该日暂无排期，选择其他星期查看更新作品。</p>
          )}
        </div>
      </div>
    </section>
  );
}